import QuizUI, { Props as UIProps } from '@interflora/ui-components/build/components/Quiz/Quiz'
import React from 'react'
import { useAnalytics } from 'hooks/useAnalytics'
import { useLoaded } from '@interflora/ui-components/build/components/MainContent/useComponentLoading'
import { populateTemplateValues } from 'utils/components'
import { NEWSLETTER_SIGNUP } from '../../graphql/queries'
import { useMutation } from '@apollo/client'
import { HandleSubmit, NewsletterSignUpValues } from '@interflora/ui-components/build/common/props'
import NewsLetterSignUpProps from '@interflora/ui-components/build/components/NewsletterSignUp/NewsletterSignUp'

type Props = UIProps
export type NewsLetterProps = Props & { newsLetterSignUpButton: typeof NewsLetterSignUpProps }
export const updateNewsLetterSignUpTemplate: NewsletterSignUpValues = {
  firstName: '',
  lastName: '',
  email: '',
}

export const getNewsLetterSignUpHandler =
  (signUpMutation: any, updateNewsLetterSignUpTemplate: NewsletterSignUpValues): HandleSubmit<NewsletterSignUpValues> =>
  async (values) => {
    try {
      const signUpValues = { ...values, email: values.email.trim() }
      const signUpNewsletterValues = populateTemplateValues(signUpValues, updateNewsLetterSignUpTemplate)
      await signUpMutation({ variables: { input: signUpNewsletterValues } })
    } catch (error) {
      console.error('Newsletter signup failed:', error)
      throw error
    }
  }

const Quiz = (props: Props) => {
  const analytics = useAnalytics()
  const [signUpMutation] = useMutation(NEWSLETTER_SIGNUP)
  const signUp = getNewsLetterSignUpHandler(signUpMutation, updateNewsLetterSignUpTemplate)

  useLoaded(props)

  return (
    <QuizUI
      {...props}
      quizStartedAnalytics={() => analytics.quizStarted()}
      quizQuestionAnsweredAnalytics={(questionNumber) => analytics.quizQuestionAnswered(questionNumber)}
      quizMarketingPageCompletedAnalytics={() => analytics.quizMarketingPageCompleted()}
      signUp={signUp}
    />
  )
}

export default Quiz
